import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import {Progress} from "./progress";
import {Count} from "./count";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {
    // Count numbers
    const numberElements = document.querySelectorAll<HTMLElement>("[data-count]");
    numberElements?.forEach((number) => {
        new Count(number);
    });

    // Progress elements
    const progressElements = document.querySelectorAll<HTMLElement>("[data-progress]");
    progressElements?.forEach((progress) => {
        new Progress(progress);
    });

    // Background Progess elements
    const bgProgressElements = document.querySelectorAll<HTMLElement>(".has-background");
    bgProgressElements?.forEach((bgProgress) => {
        new Progress(bgProgress, ['background', 'top bottom', 'center center']);
    });

    // Title elements
    const titleElements = document.querySelectorAll<HTMLElement>(".text-component__left, .text-media-component");
    titleElements?.forEach((element) => {
        const titles = element.querySelectorAll<HTMLElement>(".component-title, .component-subtitle");
        titles?.forEach(title => {
            ScrollTrigger.create({
                trigger: title,
                start: "bottom bottom",
                end: "top top",
                toggleClass: {targets: title, className: "in-view"},
                once: true,
            });
        });
    });
})